import client from '../request'

const getAll = `/packs`

const get = (id) => {
  return `/packs/${id}`
}

const create = (data) => {
  return client.post('/packs', data)
}

const update = (id, data) => {
  return client.put(`/packs/${id}`, data)
}

const addPlan = (id, data) => {
  return client.post(`/packs/${id}/plans/add`, data)
}

const removePlan = (id, planId) => {
  return client.delete(`/packs/${id}/plans/${planId}`)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/packs/${id}`)
}

const PackService = {
  getAll,
  get,
  create,
  update,
  addPlan,
  removePlan,
  toRow,
  remove,
  toPaginate
}

export default PackService
